import React, { FC } from 'react';

import { FormData } from '@/api/types';
import BackArrow from '@/assets/back-arrow.svg?react';
import LogoDeepDry from '@/assets/logo-dd.svg?react';
import Avatar from '@/components/ui/Avatar';
import Button from '@/components/ui/Button';
import { CRM_LINK } from '@/consts';
import { CaseCardVariants } from '@/features/v2/MobileMenu';
import getHelpfindPhone from '@/helpers/getHelpfindPhone';
import cn from '@/utils/cn';

export interface NavbarProps
  extends Omit<React.ComponentPropsWithoutRef<'nav'>, 'title'> {
  title?: string | React.ReactNode;
  phone?: string;
  disableMobileMenu?: boolean;
  compactPhoneButton?: boolean;
  data?: FormData;
  caseCardVariant: CaseCardVariants;
  onLogoutClick?: () => void;
  downloadPdfClick?: () => void;
  downloadPdfLoading?: boolean;
}

const NavbarDeepDry: FC<NavbarProps> = ({
  data,
  title,
  phone,
  disableMobileMenu = true,
  compactPhoneButton = false,
  className,
  ...rest
}) => {
  return (
    <nav
      id="navbar-deep-dry"
      tabIndex={-1}
      className={cn(
        'fixed z-50 min-w-full bg-dark-gray-700 lg:static',
        className
      )}
      {...rest}
    >
      <div
        className={cn(
          'mx-auto flex items-center justify-between gap-y-[14px] py-3 lg:p-3',
          'sm:max-w-screen-sm md:max-w-tablet lg:max-w-[980px]',
          'px-5 sm:px-7 lg:px-10'
        )}
      >
        <LogoDeepDry className="h-10 w-[125px] lg:w-[130px]" />
        <>
          {title && (
            <div
              className={cn(
                'caption-large items-center gap-1 text-dark-gray-100',
                disableMobileMenu ? 'hidden sm:flex' : 'flex'
              )}
            >
              {title}
            </div>
          )}
        </>
        <>
          <Button
            asChild
            size={'deepDry'}
            colors="gold"
            className={cn(
              'text-gold-400 lg:text-gold-400',
              !disableMobileMenu && 'hidden lg:flex',
              compactPhoneButton &&
                'max-lg:p-3 [&>span]:hidden [&>span]:lg:inline'
            )}
          >
            <a
              href={`tel:${phone || getHelpfindPhone(data?.product.id)}`}
              className="font-inter text-base lg:text-lg"
            >
              {phone || getHelpfindPhone(data?.product.id)}
            </a>
          </Button>
        </>
        {!disableMobileMenu && <span aria-hidden className="w-10 lg:hidden" />}
        {data?.crm_user && (
          <div className={'hidden items-center gap-x-3 lg:block'}>
            <Avatar
              img={data.crm_user.avatar}
              name={data.crm_user.name}
              variant={'clean'}
              size={'small'}
            />

            <div className="flex flex-col items-start gap-1">
              <span className="caption text-gray-100">
                Witaj, {data.crm_user.name.split(' ')[0].trim()}
              </span>
              <Button size={'xs'} asChild>
                <a
                  href={`${CRM_LINK}/leads/${data?.id}/edit`}
                  target="_blank"
                  className={'flex items-center gap-x-0.5'}
                  rel="noreferrer"
                >
                  <BackArrow className={'size-3'} />
                  <span>Wróć do CRM</span>
                </a>
              </Button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default NavbarDeepDry;
